import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAlignCenter, m, mr, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    description?: string;
    phrases: string[];
    className?: string;
}

export const ArticleListCategoryDescription: React.FC<IProps> = (props) => {
    const {className, description, phrases} = props;
    return (
        <div css={className}>
            {phrases.length > 0 && (
                <ul css={articleCategories}>
                    {phrases.map((phrase, index) => (
                        <Text as="li" variant="headline_6" key={index} css={[listDot, m(0, 0, 1.5, 0), onDesktop(m(0, 4, 0, 0))]}>
                            {phrase}
                        </Text>
                    ))}
                </ul>
            )}
            {description !== "" && (
                <Text as="div" variant="headline_6">
                    {description}
                </Text>
            )}
        </div>
    );
};

const articleCategories = css`
    list-style: none;
    padding: 0;

    ${onDesktop(flexAlignCenter)}
`;

const listDot = (theme: Theme) => css`
    vertical-align: center;
    &::before {
        ${mr(2)};
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 50%;
        background-color: ${theme.colors.primary};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAlignCenter, m, mr, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    description?: string;
    phrases: string[];
    className?: string;
}

export const ArticleListCategoryDescription: React.FC<IProps> = (props) => {
    const {className, description, phrases} = props;
    return (
        <div css={className}>
            {phrases.length > 0 && (
                <ul css={articleCategories}>
                    {phrases.map((phrase, index) => (
                        <Text as="li" variant="headline_6" key={index} css={[listDot, m(0, 0, 1.5, 0), onDesktop(m(0, 4, 0, 0))]}>
                            {phrase}
                        </Text>
                    ))}
                </ul>
            )}
            {description !== "" && (
                <Text as="div" variant="headline_6">
                    {description}
                </Text>
            )}
        </div>
    );
};

const articleCategories = css`
    list-style: none;
    padding: 0;

    ${onDesktop(flexAlignCenter)}
`;

const listDot = (theme: Theme) => css`
    vertical-align: center;
    &::before {
        ${mr(2)};
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 50%;
        background-color: ${theme.colors.primary};
    }
`;
